module.exports = __webpack_public_path__ + "img/exampleBg.a2607714.jpg";